import { render, staticRenderFns } from "./SocialNetworksConfig.vue?vue&type=template&id=29197b8c&scoped=true&"
import script from "./SocialNetworksConfig.vue?vue&type=script&lang=js&"
export * from "./SocialNetworksConfig.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworksConfig.vue?vue&type=style&index=0&id=29197b8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29197b8c",
  null
  
)

export default component.exports